module.exports = __webpack_public_path__ + "img/H4.efdd59ba.png";